import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { zodResolver } from "@hookform/resolvers/zod"
import toast from "react-hot-toast"
import { Box, Grid } from "@mui/material"
import { useCallback, useContext, useEffect } from "react"
import { useLoader } from "src/hooks/useLoader"
import { ContextOperacionNuevo, ContextOperacionNuevoType } from "../../NuevoSistema"
import { FormNuevaOperacionCLG, schemaFormNuevaOperacionCLG } from "./types/types";
import { OperacionCLGFields } from "./types/fields";
import SeccionCLGDatosOperacion from "./components/SeccionCLGDatosOperacion";
import { HttpCLG } from "./api/HttpCLG";
import { OperacionCLGInsert } from "./types/dto";
import { BaseResponseFields } from "src/types"
import SeccionCLGDatosDetalleNuevo from "./components/SeccionCLGDatosDetalleNuevo"
import { useSubmitOperacion } from "../../hooks/useSubmitOperacion"

type NuevoSistemaCLGProps = {
  codSistemaPrincipal: number
}

export const NuevoSistemaCLG = (props: NuevoSistemaCLGProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<FormNuevaOperacionCLG>({
    resolver: zodResolver(schemaFormNuevaOperacionCLG),
    defaultValues:
    {
      [OperacionCLGFields.FechaAprobacion]: new Date(),
      [OperacionCLGFields.ListaDetalles]: [],
    }
  })

  const alCrearOperacionCLG = useCallback((data: FormNuevaOperacionCLG, selected: number) => {
    const payload = {
      ...data,
      [OperacionCLGFields.BitEnvio]: selected !== 1,
      [OperacionCLGFields.CodPais]: props.codSistemaPrincipal
    };

    submitOperacion(payload, {
      apiCall: HttpCLG.post,
      successMessage: 'Guardado correctamente.',
    });
  }, [props.codSistemaPrincipal, submitOperacion]);

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    // const onSave = () => formMethods.handleSubmit(data => alCrearOperacionCLG(data, 1))

    const onSend = () => formMethods.handleSubmit(data => alCrearOperacionCLG(data, 2))

    //setSavePromise(onSave)
    setSendPromise(onSend)
  }, [])

  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <SeccionCLGDatosOperacion
            codSistemaPrincipal={props.codSistemaPrincipal}
            codSistema={codSistema}
            formMethods={formMethods}
            nuevo
          />
        </Grid>
        <Grid item xs={12}>
          <SeccionCLGDatosDetalleNuevo
            codPais={props.codSistemaPrincipal}
            formMethods={formMethods}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
